import React from 'react';

import { useTask } from 'contexts/task';
import { useUser2 } from 'contexts/user2';
import { TaskCard } from 'shell/components';
import { TYPES } from 'utils/constants';
import { getUserPreferredFullName } from 'utils/helper';

const TimelineTaskCard = ({
    task,
    onOpenTask,
    onDeleteTask,
    onDuplicateTask,
    updateTask,
    onMouseEnter,
    onMouseLeave,
}) => {
    const { taskList, subtaskList, updateSubtask } = useTask();
    const { accountUsers, currentGroupAccountUsers } = useUser2();

    task.subtasks =
        task.type === TYPES.MILESTONE
            ? Object.values(taskList.all).filter(
                  ({ active, type, milestone_id }) =>
                      active && type !== TYPES.MILESTONE && milestone_id === task.milestone_id
              )
            : Object.values(subtaskList).filter(({ active, parent_id }) => active && parent_id === task.id);

    const actionOptions = [
        { key: 'edit', value: 'Edit' },
        { key: 'delete', value: 'Delete', disabled: [TYPES.TEMPLATE, TYPES.MILESTONE].includes(task.type) },
        { key: 'duplicate', value: 'Duplicate', disabled: [TYPES.TEMPLATE, TYPES.MILESTONE].includes(task.type) },
    ];

    const handleClickComplete = (taskId, newStatus) => {
        if (Object.keys(taskList.all).includes(taskId)) {
            updateTask(taskId, 'status', newStatus, true);
        }

        if (Object.keys(subtaskList).includes(taskId)) {
            updateSubtask(taskId, 'status', newStatus);
        }
    };

    const handleSelectAction = ({ key: action }) => {
        switch (action) {
            case 'edit': {
                return onOpenTask(task.id);
            }
            case 'delete': {
                return onDeleteTask(task.id);
            }
            case 'duplicate': {
                return onDuplicateTask(task.id);
            }
            default:
                break;
        }
    };

    const handleChangeCollaborators = (taskId, accountUser) => {
        if (Object.keys(taskList.all).includes(taskId)) {
            const { collaborator_account_ids } = taskList.all[taskId];
            const newCollaborators = collaborator_account_ids?.includes(accountUser.owner_account_id)
                ? collaborator_account_ids.filter((id) => id !== accountUser.owner_account_id)
                : [...(collaborator_account_ids || []), accountUser.owner_account_id];
            updateTask(taskId, 'collaborator_account_ids', newCollaborators, true);
        }

        if (Object.keys(subtaskList).includes(taskId)) {
            const { collaborator_account_ids } = subtaskList[taskId];
            const newCollaborators = collaborator_account_ids?.includes(accountUser.owner_account_id)
                ? collaborator_account_ids.filter((id) => id !== accountUser.owner_account_id)
                : [...(collaborator_account_ids || []), accountUser.owner_account_id];
            updateSubtask(taskId, 'collaborator_account_ids', newCollaborators);
        }
    };

    const handleKeyDown = (e) => {
        const { currentTarget, key, target } = e;
        if (target === currentTarget) {
            if (key === 'Enter') {
                onOpenTask(task.id);
            }
        }
    };

    return (
        <TaskCard
            disabled={!task.show}
            task={task}
            showStatus
            variant={task.type === TYPES.MILESTONE ? TYPES.MILESTONE : 'default'}
            getNameById={(id) =>
                getUserPreferredFullName(accountUsers.find(({ owner_account_id }) => owner_account_id === id))
            }
            getUserById={(id) => accountUsers.find(({ owner_account_id }) => owner_account_id === id)}
            actionOptions={actionOptions}
            collaboratorOptions={currentGroupAccountUsers}
            onChangeCollaborator={(taskId, accountUser) => handleChangeCollaborators(taskId, accountUser)}
            onClick={onOpenTask}
            onClickComplete={handleClickComplete}
            onSelectAction={handleSelectAction}
            onKeyDown={handleKeyDown}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        />
    );
};

export default TimelineTaskCard;
